module.exports = __webpack_public_path__ + "static/media/product_userOnly_image_right_pc.758fb88d.png";